import styled from 'styled-components';

export const AdminFormContainer = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 24px 0;
  padding-bottom: 48px;
  margin: 0 auto;
`;
